(() => {
  if (customElements.get('st-product-addons')) return;
  class StProductAddOns extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.busy = false;
      this.form = this.querySelector('[data-addon-form]');
      this.submit = this.querySelector('.st-addon-submit');
      this.error = this.querySelector('[data-addon-error]');
      this.money = cents => new Intl.NumberFormat(document.documentElement.lang, {style:'currency',currency:this.dataset.currency || 'NOK',minimumFractionDigits:0,maximumFractionDigits:2}).format(cents / 100);
      const sellable = p => p.variants.some(v => v.available);
      this.rows = [...this.querySelectorAll('[data-addon-row]')].map(el => {
        const data = JSON.parse(el.querySelector('[data-addon-data]').textContent);
        const members = data.siblings.length > 1 ? data.siblings : [data.base];
        const preferred = this.dataset.color && members.find(p => p.color === this.dataset.color);
        const member = preferred || members.find(sellable) || data.base;
        const variant = member.variants.find(v => v.available && v.options.includes(this.dataset.size)) || member.variants.find(v => v.available) || member.variants[0];
        const row = {el,members,member,variant,checked:el.dataset.checked === 'true',quantity:Number(el.dataset.quantity) || 1,size:el.querySelector('[data-addon-size]'),toggle:el.querySelector('.st-addon-toggle')};
        row.toggle.addEventListener('click',()=>{if(this.busy)return;row.checked=!row.checked;this.update();});
        row.size.addEventListener('change',()=>{row.variant=row.member.variants.find(v=>String(v.id)===row.size.value);this.update();});
        this.populateSizes(row);return row;
      });
      this.form.addEventListener('submit',event=>{event.preventDefault();this.add();});
      this.update();
    }
    populateSizes(row) {
      row.size.replaceChildren();
      row.member.variants.forEach(v=>{const option=new Option(v.title+(v.available?'':' (Utsolgt)'),String(v.id));option.disabled=!v.available;row.size.add(option);});
    }
    selection() {
      const selected=this.rows.filter(r=>r.checked);
      return {total:selected.reduce((n,r)=>n+(r.variant?.price||0)*r.quantity,0),valid:selected.length>0&&selected.every(r=>r.variant?.available&&!r.variant.selling_plan),items:selected.filter(r=>r.variant?.available).map(r=>({id:r.variant.id,quantity:r.quantity,...(r.variant.selling_plan?{selling_plan:r.variant.selling_plan}:{})}))};
    }
    update() {
      this.rows.forEach(row=>{
        row.el.classList.toggle('is-excluded',!row.checked);row.toggle.setAttribute('aria-pressed',String(row.checked));row.toggle.disabled=this.busy;
        row.size.value=String(row.variant?.id||'');row.size.hidden=!row.member.variants.some(v=>v.title!=='Default Title');row.size.disabled=!row.checked||this.busy;
        row.el.querySelector('[data-addon-price]').textContent=this.money(row.variant?.price||0);
        const preorder=row.el.querySelector('[data-addon-preorder]');preorder.hidden=!row.checked||!row.variant?.selling_plan;preorder.href=(this.dataset.root||'/')+'products/'+row.member.handle+'?variant='+row.variant?.id;
        const image=row.el.querySelector('.st-addon-photo img'),src=row.variant?.image||row.member.image;
        if(image&&src&&image.getAttribute('src')!==src){image.removeAttribute('srcset');image.src=src;}
      });
      const selection=this.selection();this.querySelector('[data-addon-total]').textContent=this.money(selection.total);this.submit.disabled=this.busy||!selection.valid;
    }
    async add() {
      const selected=this.selection();if(this.busy||!selected.valid)return;
      this.busy=true;this.update();this.error.hidden=true;this.submit.setAttribute('aria-busy','true');
      const root=this.dataset.root||'/';let added=false;
      try {
        const sections=[];document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections}}));
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:selected.items,sections:[...new Set(sections)].slice(0,5),sections_url:location.pathname})});
        const result=await response.json();
        if(!response.ok)throw new Error(typeof result.description==='string'?result.description:'En av varene er ikke tilgjengelig. Kontroller valgene og prøv igjen.');
        added=true;
        if(!document.querySelector('cart-drawer')||!result.sections||Object.values(result.sections).some(s=>!s)){location.assign(root+'cart');return;}
        const cartResponse=await fetch(root+'cart.js');if(!cartResponse.ok){location.assign(root+'cart');return;}
        const cart=await cartResponse.json();cart.sections=result.sections;
        this.form.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:result.items,cart}}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',onSuccessDo:'force_open_drawer',cart}}));
      } catch(error) {
        if(added){location.assign(root+'cart');return;}
        this.error.textContent=error instanceof TypeError?'Vi fikk ikke bekreftet oppdateringen. Sjekk handlekurven før du prøver igjen.':error.message;this.error.hidden=false;
      } finally {this.busy=false;this.submit.removeAttribute('aria-busy');this.update();}
    }
  }
  customElements.define('st-product-addons',StProductAddOns);
})();
